import React from 'react';

const FM = ({ className }: { className?: string }) => (
  <svg
    className={className}
    width="21"
    height="15"
    viewBox="0 0 21 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_3_153"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="21"
      height="15"
    >
      <path
        d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_3_153)">
      <path
        d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
        fill="#72B1DF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 4H9.495C9.215 4 9 4.224 9 4.5C9 4.768 9.222 5 9.495 5H10V5.505C10 5.785 10.224 6 10.5 6C10.768 6 11 5.778 11 5.505V5H11.505C11.785 5 12 4.776 12 4.5C12 4.232 11.778 4 11.505 4H11V3.495C11 3.215 10.776 3 10.5 3C10.232 3 10 3.222 10 3.495V4ZM14 7H13.495C13.215 7 13 7.224 13 7.5C13 7.768 13.222 8 13.495 8H14V8.505C14 8.785 14.224 9 14.5 9C14.768 9 15 8.778 15 8.505V8H15.505C15.785 8 16 7.776 16 7.5C16 7.232 15.778 7 15.505 7H15V6.495C15 6.215 14.776 6 14.5 6C14.232 6 14 6.222 14 6.495V7ZM10 10H9.495C9.215 10 9 10.224 9 10.5C9 10.768 9.222 11 9.495 11H10V11.505C10 11.785 10.224 12 10.5 12C10.768 12 11 11.778 11 11.505V11H11.505C11.785 11 12 10.776 12 10.5C12 10.232 11.778 10 11.505 10H11V9.495C11 9.215 10.776 9 10.5 9C10.232 9 10 9.222 10 9.495V10ZM6 7H5.495C5.215 7 5 7.224 5 7.5C5 7.768 5.222 8 5.495 8H6V8.505C6 8.785 6.224 9 6.5 9C6.768 9 7 8.778 7 8.505V8H7.505C7.785 8 8 7.776 8 7.5C8 7.232 7.778 7 7.505 7H7V6.495C7 6.215 6.776 6 6.5 6C6.232 6 6 6.222 6 6.495V7Z"
        fill="white"
      />
      <path
        d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
        stroke="black"
        strokeOpacity="0.1"
      />
    </g>
  </svg>
);

export default FM;
